import React from "react";
import DharmaWheel from "../components/DharmaWheel";

/**
 * Square mission poster (1080 × 1080) for Instagram / Facebook / WhatsApp
 * shares. Same content as PosterMission.jsx but packed into a square
 * aspect ratio so it doesn't get cropped by feed algorithms.
 *
 * Captured by scripts/capture_posters.py.
 */
export default function PosterMissionSquare() {
  return (
    <div
      style={{
        width: 1080,
        height: 1080,
        margin: "0 auto",
        background: "#0B1F4D",
        color: "#FDFBF7",
        fontFamily: "'Work Sans', system-ui, sans-serif",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
      data-testid="poster-mission-square"
    >
      <div style={{ height: 6, background: "linear-gradient(90deg, #CFA052 0%, #E07A5F 50%, #CFA052 100%)" }} />

      {/* Header — compact for square */}
      <div style={{ padding: "32px 50px 0", display: "flex", alignItems: "center", gap: 18 }}>
        <DharmaWheel size={56} color="#CFA052" ringColor="#001B3A" />
        <div>
          <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, lineHeight: 1, fontWeight: 600 }}>
            Ambedkarite Buddhist Global Network UK
          </div>
          <div style={{ fontSize: 10, letterSpacing: "0.32em", color: "#CFA052", marginTop: 6, textTransform: "uppercase", fontWeight: 600 }}>
            Rooted in Dhamma · Inspired by Babasaheb
          </div>
        </div>
      </div>

      {/* Hero — packed tightly */}
      <div style={{ padding: "44px 50px 0", flex: 1 }}>
        <p style={{ fontSize: 11, letterSpacing: "0.32em", color: "#E07A5F", textTransform: "uppercase", fontWeight: 600, margin: 0 }}>
          Our mission
        </p>
        <h1
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: 90,
            lineHeight: 0.96,
            fontWeight: 500,
            margin: "14px 0 0",
            letterSpacing: "-0.01em",
          }}
        >
          A Sangha for <span style={{ color: "#CFA052", fontStyle: "italic" }}>everyone.</span>
        </h1>
        <p style={{ fontSize: 17, lineHeight: 1.5, color: "rgba(253,251,247,0.78)", margin: "20px 0 0", maxWidth: 880 }}>
          A <strong style={{ color: "#FDFBF7" }}>charitable public-benefit Buddhist network</strong> advancing
          teachings, education, meditation, equality, inclusion and community wellbeing through
          in-person gatherings and our own <strong style={{ color: "#FDFBF7" }}>charitable digital platform</strong>.
        </p>

        {/* 4 pillars in a row */}
        <div style={{ marginTop: 28, display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12 }}>
          {[
            { n: "01", t: "Educate", b: "Free Dhamma teachings & KS1–KS4 workbooks." },
            { n: "02", t: "Meditate", b: "Weekly live sessions on our platform." },
            { n: "03", t: "Empower", b: "Festivals, youth programmes & mutual-aid." },
            { n: "04", t: "Elevate", b: "Equality, inclusion & community cohesion." },
          ].map((p) => (
            <div key={p.n} style={{ background: "rgba(253,251,247,0.04)", border: "1px solid rgba(207,160,82,0.25)", borderRadius: 4, padding: "16px 14px" }}>
              <div style={{ fontSize: 10, letterSpacing: "0.28em", color: "#CFA052", fontWeight: 600 }}>{p.n}</div>
              <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 28, color: "#FDFBF7", marginTop: 4, lineHeight: 1 }}>{p.t}</div>
              <p style={{ fontSize: 12, lineHeight: 1.5, color: "rgba(253,251,247,0.7)", marginTop: 8 }}>{p.b}</p>
            </div>
          ))}
        </div>
      </div>

      {/* CTA band */}
      <div style={{ padding: "28px 50px", background: "linear-gradient(135deg, #001B3A 0%, #0B1F4D 100%)", borderTop: "1px solid rgba(207,160,82,0.3)", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 30 }}>
        <div>
          <p style={{ fontSize: 11, letterSpacing: "0.32em", color: "#CFA052", textTransform: "uppercase", fontWeight: 600, margin: 0 }}>
            Visit · Read · Sit · Belong
          </p>
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 28, color: "#CFA052", marginTop: 8, margin: "8px 0 0" }}>
            ambedkaritebuddhistglobalnetworkuk.com
          </p>
          <p style={{ fontSize: 12, color: "rgba(253,251,247,0.55)", marginTop: 8, lineHeight: 1.55 }}>
            Free baseline membership · hardship waivers · open to all faiths and none
          </p>
        </div>
        <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 30, fontStyle: "italic", color: "#CFA052", margin: 0, textAlign: "right", lineHeight: 1.1, flexShrink: 0 }}>
          Educate<br />Meditate<br />Empower<br />Elevate
        </p>
      </div>

      {/* Footer */}
      <div style={{ padding: "10px 50px", background: "#001B3A", borderTop: "2px solid #CFA052", display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 10, color: "rgba(253,251,247,0.6)" }}>
        <span>CIO application in preparation</span>
        <span style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: "italic", color: "#CFA052" }}>Jai Bhim · Namo Buddhāya</span>
      </div>
    </div>
  );
}
